var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-links"}},_vm._l((_vm.appLinks),function(item,index){return _c('a',{key:index,attrs:{"href":item.url,"target":"_blank"}},[_c('img',{attrs:{"src":item.icon}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }